<template>
  <AuthContainer>
    <template #form>
      <NhstIpRegistration />
    </template>
  </AuthContainer>
</template>

<script>
import {
  NhstIpRegistration,
  AuthContainer
} from '../components';
import Page from '@pages/Page.js';

export default {
  name: 'ip-registration-page',
  components: {
    NhstIpRegistration,
    AuthContainer,
  },
  extends: Page,
  methods: {
    getTitle() {
      return `${this.$store.state.corporate.company.name || 'Corporate Page'} | ${this.publication.title}`;
    }
  }
};

</script>
